import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import { TitleListEN, TitleListsCompliance } from 'store/ducks/globalTypes';
import { TitleKeyCompliance } from 'store/ducks/Management/types';
import auditFindingsWorkflow from 'constants/auditFindingsWorkflow';
import TitleBar from 'components/TitleBar';
import GoBackButton from 'components/GoBackButton';
import CardComponent from 'components/CardComponent';
import * as Styled from 'components/Layouts/Layout.styled';

const { useToken } = theme;

const AuditFindingWorkflow: React.FC = () => {
  const { token } = useToken();
  const navigate = useNavigate();
  const auditFindingsWorkflowArray = auditFindingsWorkflow();
  const lang = useSelector((state: RootState) => state.global.lang);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedArea = decodeURIComponent(query.get('selected') || '');
  const { scheme } = useSelector((state: RootState) => state.global);

  const getTitleKeyFromTitle = (
    selectedTitle: string,
    titleEnum: Record<TitleKeyCompliance, string>
  ): TitleKeyCompliance => {
    return (
      (Object.keys(titleEnum) as TitleKeyCompliance[]).find(
        (key) => titleEnum[key] === selectedTitle
      ) ?? 'COMP_EST'
    );
  };

  const TitleKeyComplianceLayout = getTitleKeyFromTitle(
    selectedArea,
    TitleListsCompliance['en']
  );

  const titles = TitleListsCompliance[lang] || TitleListEN;

  const handleCardClick = (item: {
    area: string;
    title: string;
    href: string;
  }) => {
    if (item.href) {
      navigate(item.href);
    }
  };

  return (
    <Styled.StyledLayout token={token}>
      <TitleBar
        title={titles[TitleKeyComplianceLayout]}
        goBackButtons={
          <GoBackButton to='/working_area' text='Go to Working areas' />
        }
      />
      <Styled.HorizontalLayout theme={scheme}>
        <Styled.Container>
          <Styled.GridContainer token={token}>
            {auditFindingsWorkflowArray.map((item) => (
              <Styled.RelativeContainer
                key={item.area}
                onClick={() => handleCardClick(item)}
              >
                <CardComponent
                  area={item.title}
                  infoText={''}
                  href={item.href}
                  textOnTop=''
                />
              </Styled.RelativeContainer>
            ))}
          </Styled.GridContainer>
        </Styled.Container>
      </Styled.HorizontalLayout>
    </Styled.StyledLayout>
  );
};

export default AuditFindingWorkflow;
